import api from './api';

const stageService = {
  /**
   * Fetches stages for the current user's profile and project (profile-filtered by API).
   * @param {string} [projectCode] - Optional project code to scope stages (e.g. '0198-23'); refetch when project changes.
   */
  async getStages(projectCode) {
    const params = {};
    if (projectCode) params.projectCode = projectCode;
    const response = await api.get('/stage', { params });
    return response.data;
  },

  /**
   * Fetch stage-wise visit counts for current profile + project.
   * @param {string} [projectCode]
   */
  async getVisitStageCounts(projectCode) {
    const params = {};
    if (projectCode) params.projectCode = projectCode;
    const response = await api.get('/visit/stage-counts', { params });
    return response.data;
  },
};

export default stageService;
